/**
 * Constantes da página de Contas a Pagar (Payables).
 */

import { FINANCIAL_STATUS, FINANCIAL_STATUS_LABELS, FINANCIAL_STATUS_COLORS } from '../../../constants/financial';

export const PAYABLE_STATUS = {
    PENDING: { id: FINANCIAL_STATUS.PENDING, label: FINANCIAL_STATUS_LABELS[FINANCIAL_STATUS.PENDING], color: FINANCIAL_STATUS_COLORS[FINANCIAL_STATUS.PENDING] },
    PAID: { id: FINANCIAL_STATUS.PAID, label: FINANCIAL_STATUS_LABELS[FINANCIAL_STATUS.PAID], color: FINANCIAL_STATUS_COLORS[FINANCIAL_STATUS.PAID] },
    OVERDUE: { id: FINANCIAL_STATUS.OVERDUE, label: FINANCIAL_STATUS_LABELS[FINANCIAL_STATUS.OVERDUE], color: FINANCIAL_STATUS_COLORS[FINANCIAL_STATUS.OVERDUE] },
    CANCELED: { id: FINANCIAL_STATUS.CANCELED, label: FINANCIAL_STATUS_LABELS[FINANCIAL_STATUS.CANCELED], color: FINANCIAL_STATUS_COLORS[FINANCIAL_STATUS.CANCELED] },
};

export const PAYABLE_STATUS_OPTIONS = [
    { value: "", label: "Todos os status" },
    { value: FINANCIAL_STATUS.PENDING, label: FINANCIAL_STATUS_LABELS[FINANCIAL_STATUS.PENDING] },
    { value: FINANCIAL_STATUS.PAID, label: FINANCIAL_STATUS_LABELS[FINANCIAL_STATUS.PAID] },
    { value: FINANCIAL_STATUS.OVERDUE, label: FINANCIAL_STATUS_LABELS[FINANCIAL_STATUS.OVERDUE] },
    { value: FINANCIAL_STATUS.CANCELED, label: FINANCIAL_STATUS_LABELS[FINANCIAL_STATUS.CANCELED] },
];

export const PAGE_SIZE = 500;
